import {
    SET_VENDOR_DETAILS
} from './VendorDetailsType';


const reducers = (state = [], action: any) => {
    if (action.type === SET_VENDOR_DETAILS) {
        return {
            ...state,
            vendorDropDownList: action.vendorDropDownList,
        };
    }
    else {
        return state;
    }
}

export {
    reducers
}